import { InputBase, TableCell } from "@mui/material"
import KwilDB from "kwildb"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { setEditColumn } from "../../redux/slices/cellEditColumn"
import { setEditIndex } from "../../redux/slices/cellEditIndex"
import { setEdit } from "../../redux/slices/cellEditSlice"

export default function DbCell({ index, row, column, editMode, submitEdit,varType, setErrMsg}) {
    const [cellEdit, setCellEdit] = useState(row[column])
    const [newInput, setNewInput] = useState("")
    const [edited, setEdited] = useState(false)
    
    const dispatch = useDispatch()
    
    useEffect(() => {
        if (edited) {
            dispatch(setEdit(newInput))
            dispatch(setEditIndex(row.row_id))
            dispatch(setEditColumn(column))
        }
    }, [submitEdit])

    return(
        editMode ?
            <TableCell
                key={index}
                size="small"
                sx={{
                    color: "#fff",
                    borderBottom: "none",
                    height: "45px",
                }}
            >
                <InputBase
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                        width: "100%",
                        margin: "auto"
                    }}
                    id="outlined-basic"
                    variant="filled"
                    label=""
                    placeholder={`Add new ${varType[index]}`}
                    onChange={(e) => {
                        if(column === "row_id") {
                            setErrMsg("Cannot edit row_id!")
                        } else {
                            setNewInput(e.target.value)
                            setNewInput(e.target.value)
                            setEdited(true)
                        }
                    }}
                    value={edited ? newInput : cellEdit}
                />
            </TableCell>
        :
            <TableCell
                key={index}
                size="small"
                sx={{
                    color: "#fff",
                    borderBottom: "none",
                    height: "45px",
                }}
                colSpan="1"
            >
                {typeof row[column] === "boolean" ? row[column].toString() : row[column]}
            </TableCell>
 
    )
}
